import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import { getStatusRequest } from 'state/scheduledRuns/selectors';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';

export function pauseScheduledRunEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) => {
    const { updateRunRequest } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_PAUSE_SCHEDULE_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) => {
        const req = getStatusRequest(state, id, 'Paused');
        if (!req) {
          return EMPTY;
        }
        return updateRunRequest(req.runId, req.etag, req.request, getWorkspaceType(state, id)).pipe(
          map(() => scheduledRunActions.pauseScheduleSucceeded(id, req.runId)),
          catchError((err: HttpError) => {
            return of(scheduledRunActions.pauseScheduleFailed(id, toTypedError('Pricing Runs DIY', err)));
          }),
        );
      }),
    );
  };
}
